<template>
  <div class="container">
    <el-card>
      <div slot="header">控制管理</div>
      <div style="height: 100%">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="电表" name="electric">
            <div style="display: flex; overflow: hidden; height: 100%">
              <div class="leftTree">
                <MerchantTree ref="merchantTree" :showCheckBox="false" v-on:treeMenuClick="treeMenuClick"></MerchantTree>
              </div>
              <div class="rightTable">
                <div style="margin-bottom: 10px">
                  <el-button type="primary" @click="paymentDetail" size="small">缴费详情</el-button>
                  <el-button type="primary" size="small" @click="electricGateRecord">开合闸记录</el-button>
                  <el-button type="primary" @click="openGateDialog" size="small">开闸</el-button>
                  <el-button type="primary" @click="closeGateDialog" size="small">合闸</el-button>
                  <el-button type="primary" @click="refreshHandleQuery" size="small">刷新</el-button>
                </div>
                <div class="tableStyle">
                  <el-table :data="electricTableData" style="width: 100%" height="92%">
                    <el-table-column prop="editorTime" label="创建时间" width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="editorName" label="创建人" width="120" align="center">
                    </el-table-column>
                    <el-table-column prop="meterAddr" label="电表编号" align="center">
                    </el-table-column>
                    <el-table-column prop="model" label="电表型号" align="center">
                    </el-table-column>
                    <el-table-column prop="type" label="电表制式" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="producer" label="电表厂商" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="breakFlag" label="拉合闸状态" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="ctRatio" label="CT变比" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" align="center">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="水表" name="water">
            <div style="display: flex; overflow: hidden">
              <div class="leftTree">
                <MerchantTree ref="merchantTree1" :showCheckBox="false" v-on:treeMenuClick="treeMenuClickWater"></MerchantTree>
              </div>
              <div class="rightTable">
                <div style="margin-bottom: 10px">
                  <el-button type="primary" size="small" @click="paymentDetailWater">缴费详情</el-button>
                  <el-button type="primary" size="small" @click="waterGateRecord">开合阀记录</el-button>
                  <el-button type="primary" @click="openValve" size="small">开阀</el-button>
                  <el-button type="primary" @click="closeValve" size="small">合阀</el-button>
                  <el-button type="primary" @click="refreshHandleQueryWater" size="small">刷新
                  </el-button>
                </div>
                <div class="tableStyle">
                  <el-table :data="waterTableData" style="width: 100%" height="92%">
                    <el-table-column prop="editorTime" label="创建时间" align="center">
                    </el-table-column>
                    <el-table-column prop="editorName" label="创建人" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="meterAddr" label="水表编号" align="center">
                    </el-table-column>
                    <el-table-column prop="model" label="水表型号" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="producer" label="水表厂商" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="breakFlag" label="拉合阀状态" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" align="center">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!-- 电表开合闸记录 -->
    <el-dialog title="电表开合闸记录查询" :visible.sync="meterOnOffDialogVisible" width="80%">
      <div>
        <el-form ref="form" :model="form" label-width="80px" size="small">
          <el-form-item label="操作时间" label-width="70px">
            <el-date-picker v-model="queryParams.createStartTime" type="datetime" placeholder="选择开始日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
            </el-date-picker>
            <label> 到 </label>
            <el-date-picker v-model="queryParams.createEndTime" type="datetime" placeholder="选择结束日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商户名称">
            <el-select v-model="queryParams.lesseeId" placeholder="请选择" clearable filterable>
              <el-option v-for="item in merchantNameOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开合闸类型" label-width="88px">
            <el-select v-model="queryParams.recordType" placeholder="请选择" clearable filterable>
              <el-option v-for="item in breakStateOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px" @click="getSelectListBreakAndEnable">搜索</el-button>
        </el-form>
        <div class="tableStyle">
          <el-table :data="electricBreakTableData" style="width: 100%" height="94%">
            <el-table-column prop="editorTime" label="操作时间" align="center">
            </el-table-column>
            <el-table-column prop="editorName" label="操作人" width="100" align="center">
            </el-table-column>
            <el-table-column prop="lesseeCode" label="商户编号" align="center">
            </el-table-column>
            <el-table-column prop="lesseeName" label="商户名称" align="center">
            </el-table-column>
            <el-table-column prop="meterAddr" label="电表编号" align="center">
            </el-table-column>
            <el-table-column prop="recordType" label="开合闸类型" width="100" align="center">
            </el-table-column>
            <el-table-column prop="meterModel" label="电表型号" width="140" align="center">
            </el-table-column>
            <el-table-column prop="meterType" label="电表制式" width="140" align="center">
            </el-table-column>
            <el-table-column prop="meterProducer" label="电表厂商" width="100" align="center">
            </el-table-column>
            <el-table-column prop="meterRatio" label="CT变比" width="80" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="200" align="center">
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: center;">
            <el-pagination v-show="total > 0" @size-change="getSelectListBreakAndEnable" @current-change="getSelectListBreakAndEnable" :current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]" :page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="meterOnOffDialogVisible = false">返 回</el-button>
      </div>
    </el-dialog>
    <!-- 水表开合阀记录 -->
    <el-dialog title="水表开合阀记录查询" :visible.sync="waterOnOffDialogVisible" width="80%">
      <div>
        <el-form :model="form1" label-width="80px" size="small">
          <el-form-item label="操作时间" label-width="70px">
            <el-date-picker v-model="queryParamsWater.createStartTime" type="datetime" placeholder="选择开始日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
            </el-date-picker>
            <label> 到 </label>
            <el-date-picker v-model="queryParamsWater.createEndTime" type="datetime" placeholder="选择结束日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商户名称">
            <el-select v-model="queryParamsWater.lesseeId" placeholder="请选择" clearable filterable>
              <el-option v-for="item in merchantNameOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开合阀类型" label-width="90px">
            <el-select v-model="queryParamsWater.recordType" placeholder="请选择" clearable filterable>
              <el-option v-for="item in breakStateOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px" @click="getSelectListWaterBreakAndEnable">搜索</el-button>
        </el-form>
        <div class="tableStyle">
          <el-table :data="waterBreakTableData" style="width: 100%" height="94%">
            <el-table-column prop="editorTime" label="操作时间" align="center">
            </el-table-column>
            <el-table-column prop="editorName" label="操作人" width="100" align="center">
            </el-table-column>
            <el-table-column prop="lesseeCode" label="商户编号" align="center">
            </el-table-column>
            <el-table-column prop="lesseeName" label="商户名称" align="center">
            </el-table-column>
            <el-table-column prop="meterAddr" label="水表编号" align="center">
            </el-table-column>
            <el-table-column prop="recordType" label="开合阀类型" width="100" align="center">
            </el-table-column>
            <el-table-column prop="meterModel" label="水表型号" width="140" align="center">
            </el-table-column>
            <el-table-column prop="meterProducer" label="水表厂商" width="100" align="center">
            </el-table-column>

            <el-table-column prop="remark" label="备注" width="200" align="center">
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: center;">
            <el-pagination v-show="waterTotal > 0" @size-change="getSelectListWaterBreakAndEnable" @current-change="getSelectListWaterBreakAndEnable" :current-page.sync="queryParamsWater.current" :page-sizes="[100, 200, 400, 600, 800, 1000]" :page-size.sync="queryParamsWater.size" layout="total, sizes, prev, pager, next, jumper" :total="waterTotal">
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="waterOnOffDialogVisible = false">返 回</el-button>
      </div>
    </el-dialog>
    <!-- 电缴费详情 -->
    <el-dialog title="缴费详情" :visible.sync="paymentDialogVisible" width="1300px">
      <el-table :data="paymentDetailTableData" style="width: 100%">
        <el-table-column type="index" width="50" label="序号" align="center"> </el-table-column>
        <el-table-column align="center" prop="editorTime" label="创建时间" width="160">
        </el-table-column>
        <el-table-column align="center" prop="editorName" label="创建人">
        </el-table-column>
        <el-table-column prop="lesseeCode" label="商户编号" align="center">
        </el-table-column>
        <el-table-column prop="lesseeName" label="商户名称" width="150" align="center">
        </el-table-column>
        <el-table-column prop="money" label="售电金额(元)" width="110" align="center">
        </el-table-column>
        <el-table-column prop="payType" label="付款方式" width="150" align="center">
        </el-table-column>
        <el-table-column prop="onlineOffline" label="线上线下" width="120" align="center">
        </el-table-column>
        <el-table-column prop="lesseeType" label="商户业态" width="150" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="150" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 水缴费详情 -->
    <el-dialog title="缴费详情" :visible.sync="paymentWaterDialogVisible" width="1300px">
      <el-table :data="paymentDetailTableDataWater" style="width: 100%">
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <el-table-column align="center" prop="editorTime" label="创建时间" width="160">
        </el-table-column>
        <el-table-column align="center" prop="editorName" label="创建人">
        </el-table-column>
        <el-table-column prop="lesseeCode" label="商户编号" align="center">
        </el-table-column>
        <el-table-column prop="lesseeName" label="商户名称" width="150" align="center">
        </el-table-column>
        <el-table-column prop="money" label="售水金额(元)" width="110" align="center">
        </el-table-column>
        <el-table-column prop="payType" label="付款方式" width="110" align="center">
        </el-table-column>
        <el-table-column prop="onlineOffline" label="线上线下" width="120" align="center">
        </el-table-column>
        <el-table-column prop="lesseeType" label="商户业态" width="150" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="150" align="center">
        </el-table-column>
        <!-- <el-table-column prop="notifyFlag" label="是否开票" align="center">
        </el-table-column> -->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentWaterDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 开闸\合闸密码确认 -->
    <el-dialog :title="electricDialogTitle" :visible.sync="passwordDialogVisible" width="30%">
      <el-form ref="gateValidForm" :model="gateValidForm" label-width="85px">
        <el-form-item label="验证手机号" style="width: 100%">
          <el-input v-model="adminPhone" disabled></el-input>
        </el-form-item>
        <el-input placeholder="请获取验证码" v-model="verifyCode">
          <template slot="append" class="getValidStyle">
            <el-button type="primary" @click="getValidMessage" v-show="verifyCodeShow">获取验证码</el-button>
            <span v-show="!verifyCodeShow">
              <span> {{ countDown }} </span> 秒之后重新发送验证码</span>
          </template>
        </el-input>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="gateControl">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 开闸\合闸密码确认 -->
    <el-dialog :title="passwordConfirmationDialogTitle" :visible.sync="passwordConfirmationDialogVisible" width="30%">
      <el-form ref="passwordConfirmationForm" :model="passwordConfirmationForm" label-width="85px">
        <el-form-item label="验证密码" style="width: 100%">
          <el-input v-model="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordConfirmationDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="gateControl">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  // selectListElectric,
  // selectListWater,
  breakMeter,
  enableMeter,
  selectListByLesseeId,
  getAdminPhone,
  getSmsVerifyCode,
  selectListByLesseeIdWater,
  enableWater,
  breakWater,
  selectListMeterById,
  selectListWaterById,
  selectListBreakAndEnable,
  selectListWaterBreakAndEnable,
  breakMeterManByPassword,
  enableMeterManByPassword,
  breakWaterManByPassword,
  enableWaterManByPassword
} from '../../api/property/controlManage';
import {
  translateObjectEmptyAttributeToNull
} from '../../untils/func';
import {
  selectLessee,
  selectDictionaryListByName,
} from '../../api/comboboxLoad';
import MerchantTree from './MerchantTree.vue';
import dictionaryConstant from '../../constant/dictionaryConstant';
import systemConstant from '../../constant/systemConstant';
import { selectDicValueByDicKey } from '../../api/system/systemCustomConfig';
import md5 from 'js-md5';
export default {
  components: {
    MerchantTree,
  },
  data () {
    return {
      form: {},
      form1: {},
      passwordDialogVisible: false,
      paymentDialogVisible: false,
      paymentWaterDialogVisible: false,
      activeName: 'electric',
      electricDialogTitle: '请输入开闸密码',
      adminPhone: '',
      verifyCode: '',
      // 查询参数
      queryParams: {
        current: 1,
        size: 100,
        createStartTime: '',
        createEndTime: '',
        lesseeId: ''
      },
      queryParamsWater: {
        current: 1,
        size: 100,
        createStartTime: '',
        createEndTime: '',
        lesseeId: ''
      },
      loading: false,
      electricTableData: [],
      waterTableData: [],
      currentRow: null,
      areaTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      filterText: '',
      gateValidForm: {},
      paymentDetailTableData: [],
      paymentDetailTableDataWater: [],
      lesseeId: '',
      verifyCodeShow: true,
      countDown: 120,
      meterOnOffDialogVisible: false,
      waterOnOffDialogVisible: false,
      merchantNameOptions: [],
      breakStateOptions: [],

      electricBreakTableData: [],
      waterBreakTableData: [],
      total: 0,
      waterTotal: 0,
      password: '',
      passwordConfirmationForm: {},
      passwordConfirmationDialogVisible: false,
      passwordConfirmationDialogTitle: '',
      meterOpenCloseMethod: '',
      waterMeterOpenCloseMethod: '',
    };
  },
  created () {
    this.init();
  },
  mounted () { },
  watch: {},
  methods: {
    async init () {
      // await this.handleQuery();
      await this.getBreakState();
      await this.getSelectLessee();
    },
    async refreshHandleQuery () {
      await this.getSelectListByLesseeId();
      this.msgSuccess('刷新成功');
    },
    async refreshHandleQueryWater () {
      await this.getSelectListByLesseeIdWater();
      this.msgSuccess('刷新成功');
    },
    // 查询pc端商户电表列表
    async getSelectListByLesseeId () {
      const res = await selectListByLesseeId({
        lesseeId: this.currentRow,
      }).then();
      this.electricTableData = res.data;
      this.loading = false;
    },
    // 查询pc端商户水表列表
    async getSelectListByLesseeIdWater () {
      const res = await selectListByLesseeIdWater({
        lesseeId: this.currentRowW,
      }).then();
      this.waterTableData = res.data;
      this.loading = false;
    },
    // 获取超级管理元手机号
    async getAdminPhone () {
      const res = await getAdminPhone().then();
      this.adminPhone = res.data;
    },
    // 获取短信验证码
    async getValidMessage () {
      await getSmsVerifyCode({
        phone: this.adminPhone
      }).then();
      this.verifyCodeShow = false;
      this.msgSuccess('发送成功');
      this.countDown = 120;
      var downTimer = setInterval(() => {
        this.countDown--;
        if (this.countDown <= 0) {
          this.verifyCodeShow = true;
          clearInterval(downTimer);
        }
      }, 1000);
    },
    async treeMenuClick () {
      this.currentRow = this.$refs.merchantTree.nodeId;
      await this.getSelectListByLesseeId();
    },
    async treeMenuClickWater () {
      this.currentRowW = this.$refs.merchantTree1.nodeId;
      await this.getSelectListByLesseeIdWater();
    },

    async openGateDialog () {
      if (this.currentRow == null) {
        this.$message.error('请先选择某个商户！');
      } else {
        await this.getMeterOpenCloseMethod();
        if (this.meterOpenCloseMethod == systemConstant.ARREARS_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD) {
          this.passwordConfirmationDialogTitle = '请验证开闸';
          this.passwordConfirmationDialogVisible = true;
          this.password = '';
        } else if (this.meterOpenCloseMethod == systemConstant.ARREARS_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD) {
          this.electricDialogTitle = '请验证开闸';
          this.passwordDialogVisible = true;
          this.verifyCode = '';
          await this.getAdminPhone();
        }

      }
    },
    async closeGateDialog () {
      if (this.currentRow == null) {
        this.$message.error('请先选择某个商户！');
      } else {
        await this.getMeterOpenCloseMethod();
        if (this.meterOpenCloseMethod == systemConstant.ARREARS_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD) {
          this.passwordConfirmationDialogTitle = '请验证合闸';
          this.passwordConfirmationDialogVisible = true;
          this.password = '';
        } else if (this.meterOpenCloseMethod == systemConstant.ARREARS_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD) {
          this.electricDialogTitle = '请验证合闸';
          this.passwordDialogVisible = true;
          this.verifyCode = '';
          await this.getAdminPhone();
        }
      }
    },
    async gateControl () {
      if (this.activeName == 'electric') {
        if (this.meterOpenCloseMethod == systemConstant.ARREARS_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD) {
          if (this.electricDialogTitle == '请验证开闸') {
            await breakMeter({
              id: this.currentRow,
              verifyCode: this.verifyCode,
            }).then();
          } else if (this.electricDialogTitle == '请验证合闸') {
            await enableMeter({
              id: this.currentRow,
              verifyCode: this.verifyCode,
            }).then();
          }
          this.passwordDialogVisible = false;
          this.meterOpenCloseMethod = '';
          this.verifyCode = '';
          this.msgSuccess('操作成功');
        } else if (this.meterOpenCloseMethod == systemConstant.ARREARS_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD) {
          if (this.password != '') {
            let passwordParma = md5(this.password);
            if (this.passwordConfirmationDialogTitle == '请验证开闸') {
              await breakMeterManByPassword({
                id: this.currentRow,
                password: passwordParma,
              }).then();
            } else if (this.passwordConfirmationDialogTitle == '请验证合闸') {
              await enableMeterManByPassword({
                id: this.currentRow,
                password: passwordParma,
              }).then();
            }
            this.passwordConfirmationDialogVisible = false;
            this.password = '';
            this.meterOpenCloseMethod = '';
            this.msgSuccess('操作成功');
          } else {
            this.$message.error('请输入密码');
          }
        }
      } else {
        if (this.waterMeterOpenCloseMethod == systemConstant.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD) {
          if (this.electricDialogTitle == '请验证开阀') {
            await breakWater({
              id: this.currentRowW,
              verifyCode: this.verifyCode,
            }).then();
          } else if (this.electricDialogTitle == '请验证关阀') {
            await enableWater({
              id: this.currentRowW,
              verifyCode: this.verifyCode,
            }).then();
          }
          this.passwordDialogVisible = false;
          this.waterMeterOpenCloseMethod = '';
          this.verifyCode = '';
          this.msgSuccess('操作成功');
        } else if (this.waterMeterOpenCloseMethod == systemConstant.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD) {
          if (this.password != '') {
            let passwordParma = md5(this.password);
            if (this.passwordConfirmationDialogTitle == '请验证开阀') {
              await breakWaterManByPassword({
                id: this.currentRowW,
                password: passwordParma,
              }).then();
            } else if (this.passwordConfirmationDialogTitle == '请验证关阀') {
              await enableWaterManByPassword({
                id: this.currentRowW,
                password: passwordParma,
              }).then();
            }
            this.passwordConfirmationDialogVisible = false;
            this.password = '';
            this.waterMeterOpenCloseMethod = '';
            this.msgSuccess('操作成功');
          } else {
            this.$message.error('请输入密码');
          }
        }

      }

    },
    async openValve () {
      if (this.currentRowW == null) {
        this.$message.error('请先选择某个商户！');
      } else {
        await this.getWaterMeterOpenCloseMethod();
        if (this.waterMeterOpenCloseMethod == systemConstant.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD) {
          this.passwordConfirmationDialogTitle = '请验证开阀';
          this.passwordConfirmationDialogVisible = true;
          this.password = '';
        } else if (this.waterMeterOpenCloseMethod == systemConstant.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD) {
          this.electricDialogTitle = '请验证开阀';
          this.passwordDialogVisible = true;
          this.verifyCode = '';
          await this.getAdminPhone();
        }
      }
    },
    async closeValve () {
      if (this.currentRowW == null) {
        this.$message.error('请先选择某个商户！');
      } else {
        await this.getWaterMeterOpenCloseMethod();
        if (this.waterMeterOpenCloseMethod == systemConstant.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD) {
          this.passwordConfirmationDialogTitle = '请验证关阀';
          this.passwordConfirmationDialogVisible = true;
          this.password = '';
        } else if (this.waterMeterOpenCloseMethod == systemConstant.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD) {
          this.electricDialogTitle = '请验证关阀';
          this.passwordDialogVisible = true;
          this.verifyCode = '';
          await this.getAdminPhone();
        }

      }
    },
    // 根据nodeID查询电表
    async getSelectListMeterById () {
      const res = await selectListMeterById({
        lesseeId: this.currentRow,
      }).then();
      this.paymentDetailTableData = res.data;
    },
    // 根据nodeID查询水表
    async getSelectListWaterById () {
      const res = await selectListWaterById({
        lesseeId: this.currentRowW,
      }).then();
      this.paymentDetailTableDataWater = res.data;
    },
    // 电缴费详情
    async paymentDetail () {
      if (this.currentRow == null) {
        this.$message.error('请先选择某个商户！');
      } else {
        this.paymentDialogVisible = true;
        await this.getSelectListMeterById();
      }
    },
    // 水缴费详情
    async paymentDetailWater () {
      if (this.currentRowW == null) {
        this.$message.error('请先选择某个商户！');
      } else {
        this.paymentWaterDialogVisible = true;
        await this.getSelectListWaterById();
      }
    },
    // 获取商户名称下拉列表数据
    async getSelectLessee () {
      const res = await selectLessee().then();
      this.merchantNameOptions = res.data;
    },
    // 获取 开合闸类型 下拉列表 数据
    async getBreakState () {
      // 接线方式
      const res = await selectDictionaryListByName(
        dictionaryConstant.BREAK_AND_ENABLE_GATE_TYPE
      ).then();
      this.breakStateOptions = res.data;
    },
    // 电表开合闸记录
    async electricGateRecord () {
      this.queryParams = {
        current: 1,
        size: 100,
        createStartTime: '',
        createEndTime: '',
        lesseeId: ''
      };
      if (this.currentRow !== null && this.currentRow !== undefined && this.currentRow !== '') {
        this.queryParams.lesseeId = Number(this.currentRow);
      }
      this.meterOnOffDialogVisible = true;
      await this.getSelectListBreakAndEnable();

    },
    // 电开合闸记录
    async getSelectListBreakAndEnable () {
      let param = this.queryParams;
      param = translateObjectEmptyAttributeToNull(param);
      const res = await selectListBreakAndEnable(param).then();
      this.electricBreakTableData = res.data;
      this.total = res.total;
    },
    async waterGateRecord () {
      this.queryParamsWater = {
        current: 1,
        size: 100,
        createStartTime: '',
        createEndTime: '',
        lesseeId: ''
      };
      if (this.currentRowW !== null && this.currentRowW !== undefined && this.currentRowW !== '') {
        this.queryParamsWater.lesseeId = Number(this.currentRowW);
      }
      this.waterOnOffDialogVisible = true;
      await this.getSelectListWaterBreakAndEnable();
    },
    // 水表开合闸记录
    async getSelectListWaterBreakAndEnable () {
      let param = this.queryParamsWater;
      param = translateObjectEmptyAttributeToNull(param);
      const res = await selectListWaterBreakAndEnable(param).then();
      this.waterBreakTableData = res.data;
      this.waterTotal = res.total;
    },
    async getMeterOpenCloseMethod () {
      const resMeter = await selectDicValueByDicKey(systemConstant.ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD).then();
      this.meterOpenCloseMethod = resMeter.data;
    },
    async getWaterMeterOpenCloseMethod () {
      const res = await selectDicValueByDicKey(systemConstant.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD).then();
      this.waterMeterOpenCloseMethod = res.data;
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}

/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

/deep/ .el-form-item {
  display: inline-block;
  margin-bottom: 10px;
}

.searchTag {
  width: 200px;
}

.btns {
  margin-top: 10px;
}

/deep/ .el-tabs {
  height: 100% !important;

  .el-tabs__content {
    height: calc(100% - 39px) !important;
  }
}

/deep/ .el-tabs__content {
  height: 100% !important;
}

.tableStyle {
  height: calc(100vh - 460px);
}

/deep/ .el-input-group__append {
  cursor: pointer;
}

.leftTree {
  width: 15vw;
  height: 100%;
  min-width: 180px;
  margin-right: 20px;
}

.rightTable {
  width: 90%;
}

.el-tab-pane {
  height: 100% !important;
}

/deep/ .el-table--scrollable-x .el-table__body-wrapper {
  overflow: auto !important;
}

.block {
  margin-top: 10px;
}
</style>
